"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.store = void 0;

var _utils = require("../utils");

var _constants = require("./constants");

var createStore = function createStore(storage, key) {
  return function (value) {
    var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (remove) {
      storage.removeItem(key);
    }

    if (value) {
      storage.setItem(key, value);
    }

    return storage.getItem(key);
  };
};

var udsStore = createStore(localStorage, 'onvio-uds-token');
var store = {
  jwt: createStore(sessionStorage, 'tr-auth-token'),
  uds: function uds(value) {
    var _udsStore;

    var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (remove) {
      (0, _utils.cookie)(_constants.tokenType, null, '/');
      (0, _utils.cookie)(_constants.tokenType, null);
      udsStore(value, remove);
    }

    if (value) {
      (0, _utils.cookie)(_constants.tokenType, value, _constants.cookiePath);
      udsStore(value, remove);
    }

    return (_udsStore = udsStore(value, remove)) !== null && _udsStore !== void 0 ? _udsStore : (0, _utils.cookie)(_constants.tokenType);
  }
};
exports.store = store;
